import { Action, createReducer, on } from '@ngrx/store';
import { IUserBlockedUpdateRequest, IUserBlockedUpdateResponse } from '../models/block.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { updateUserBlockedRequest, updateUserBlockedSuccess, updateUserBlockedFailure } from '../actions/block.actions';

export const userBlockedFeatureKey = 'userBlocked';

export interface UserBlockedState {
  blockUserRequest: IUserBlockedUpdateRequest;
  blockUserSuccess: IUserBlockedUpdateResponse;
  blockUserFailure: IGenericError<ErrorResponse>;
}

export const initialState: UserBlockedState = {
  blockUserRequest: undefined,
  blockUserSuccess: undefined,
  blockUserFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(updateUserBlockedRequest, (state, action) => ({
    ...state,
    blockUserRequest: action.request
  })),
  on(updateUserBlockedSuccess, (state, action) => ({
    ...state,
    blockUserSuccess: action.response
  })),
  on(updateUserBlockedFailure, (state, action) => ({
    ...state,
    blockUserFailure: action.error
  }))
);

export const getBlockUserRequest = (state: UserBlockedState) => state.blockUserRequest;
export const getBlockUserResponse = (state: UserBlockedState) => state.blockUserSuccess;
export const getBlockUserFailure = (state: UserBlockedState) => state.blockUserFailure;
